import { render, staticRenderFns } from "./command.vue?vue&type=template&id=4415f438&scoped=true"
import script from "./command.vue?vue&type=script&lang=js"
export * from "./command.vue?vue&type=script&lang=js"
import style0 from "./command.vue?vue&type=style&index=0&id=4415f438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4415f438",
  null
  
)

export default component.exports